import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalDialog = (props) => {
    const refContents = React.createRef(null);
    React.useEffect(() => {
        if(props.display) {
            refContents.current.scrollTo(0, 0);
        }
    }, [props.display])
    const createControls = () => {
        let ret = [];
        let index = 0;
        for(let caption in props.controls){
            const propsControl = props.controls[caption];
            ret.push(
                <Control key={index} Color={propsControl.Color} Size={propsControl.Size} Height={propsControl.Height} onClick={propsControl.onClick}>
                    {caption}
                </Control>
            )
            index++;
        }
        return ret;
    }
    return (
        <Body Type={props.type} Display={props.display}>
            <Back Display={props.display}></Back>
            <Dialog Display={props.display}>
                <Contents ref={refContents}>
                    {props.contents}
                </Contents>
                <ControlWrap>
                    {createControls()}
                </ControlWrap>
            </Dialog>
        </Body>
    );
}

export { ModalDialog };

ModalDialog.propTypes = {
    controls: PropTypes.object.isRequired,
    display: PropTypes.bool.isRequired,
    type: PropTypes.number,
};

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
    position: ${props => props.Type ? "fixed" : "absolute"};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: ${props => (props.Display ? '50%' : '47%')};
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: center;
    transition-duration: 0.2s;

    border-radius: 10px;

    width: 90%;
    max-width: 350px;
    z-index: 3;
`;

const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 10px 0 10px 0;
    font-size: 14px;
    min-height: 100px;
    max-height: 450px;
    overflow-y: auto;
`;

const ControlWrap = styled.div`
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #ddd;
`;
const Control = styled.div`
    flex: 1;
    color: ${props => (props.Color)};
    font-size: ${props => props.Size ? props.Size : "inherit"};
    height: ${props => props.Height ? props.Height : "auto"};
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    :nth-of-type(n+2) {
        border-left: 1px solid #ddd;
    }
    cursor: pointer;
`;
